const locale = {
  PERSONAL: 'Información Personal',
  SKILLS: 'Actualiza tus habilidades',
  COURSES: 'Cursos Guardados',
  PROFILE: 'Perfil',
  PROFILE_NAV_ARIA_LABEL: 'Navegación del perfil',
};

export default locale;
